import React from "react";

function formatMoney(n) {
	return `$${Number(n || 0).toFixed(2)}`;
}

export default function SpendAttentionCard({ spend, attention }) {
	const pct = Math.min(100, Math.max(0, spend?.pct ?? 0));
	const items = attention || [];

	return (
		<article className="monitoring__panel monitoring__panel--spend">
			{/* <div className="monitoring__spend-block">
				<h3 className="monitoring__panel-title">Month-to-date spend vs budget</h3>
				<p className="monitoring__spend-amount mb-2">
					{formatMoney(spend?.used)} of {formatMoney(spend?.cap)} cap
				</p>
				<div
					className="monitoring__spend-bar"
					role="progressbar"
					aria-valuenow={pct}
					aria-valuemin={0}
					aria-valuemax={100}
					aria-label="Budget used"
				>
					<div className="monitoring__spend-bar-fill" style={{ width: `${pct}%` }} />
				</div>
				<p className="monitoring__metric-hint mb-0 mt-2">
					{pct}% used. Runs skip and journal{" "}
					<code className="monitoring__inline-code">budget_exceeded</code> at the cap.
				</p>
			</div> */}

			<div className="monitoring__attention-block">
				<h3 className="monitoring__panel-title monitoring__attention-title">
					Needs attention
				</h3>
				{items.length === 0 ? (
					<p className="monitoring__empty text-muted mb-0">
						Nothing needs attention right now.
					</p>
				) : (
					<ul className="monitoring__attention-list list-unstyled mb-0">
						{items.map((item, index) => (
							<li
								key={item.id ?? index}
								className="monitoring__attention-item"
							>
								<span
									className="monitoring__attention-marker"
									aria-hidden
								/>
								<span className="monitoring__attention-message">
									{item.message}
								</span>
								{item.dateLabel ? (
									<span className="monitoring__attention-date">
										{item.dateLabel}
									</span>
								) : null}
							</li>
						))}
					</ul>
				)}
			</div>
		</article>
	);
}
